module.exports = __webpack_public_path__ + "img/LBNorm_1280x1010.045177a9.jpg";